import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import Err from "../../../../routes/error";
import { SET_SESSION_DETAILS, SET_NOTIFICATION_PREFERENCES, SET_PERSONAL_DETAILS, SET_CLIENT_BOARD_VIEW, SET_ACCOUNT_DETAILS, SET_EMAIL_SIGNATURE, SET_ACCOUNT_PREFERENCES, SET_EMAIL_VERIFICATION, SET_STYLES, SET_TIED_BROKERAGE } from "./account-mutations";
import { getNotificationPreferences, updateNotificationPreferences, updateAccountPreferences, getEmailSignature, updateEmailSignature, updateDomain, updatePersonalDetails, uploadToS3, setProfilePhoto, getPhotoSignedURL, removeProfilePhoto, getAccountType, createAccount, verifyAccountEmail, resendConfirmationCode, getAccountDetails, login, confirmSelectedMfaAndSendCode, enableMfa, validateMfa, snoozeMfaForLater, resendMfaCode } from "../../api/account-api";
import Vue from "vue";
import { agreedToTerms } from "@Broker/@Modules/marketing/api/marketing-api";
import { omitDeep, clearPreferencesBooleans, delay } from "@Shared/utils/utils";
import Amplitude from "@Shared/utils/amplitude";
import { getAccountsApi } from "@Shared/@Utils/ajax";
import { getCurrentColor } from "@Shared/utils/utils";
import { find } from "lodash";
import PendoUtils from "@Shared/@Utils/pendo";
import i18n from "@Shared/i18n";
export const INIT_SESSION = "INIT_SESSION";
export const UPDATE_ACCOUNT_PREFERENCES = "UPDATE_ACCOUNT_PREFERENCES";
export const UPDATE_LOCALE_PREFERENCES = "UPDATE_LOCALE_PREFERENCES";
export const UPDATE_ACCOUNT_PERSONAL_DETAILS = "UPDATE_ACCOUNT_PERSONAL_DETAILS";
export const LOAD_NOTIFICATION_PREFERENCES = "LOAD_NOTIFICATION_PREFERENCES";
export const UPDATE_NOTIFICATION_PREFERENCES = "UPDATE_NOTIFICATION_PREFERENCES";
export const SAVE_BOARD_VIEW = "SAVE_BOARD_VIEW";
export const LOAD_PERSONAL_DETAILS = "LOAD_PERSONAL_DETAILS";
export const WS_REFRESH_HIERARCHY_DETAILS = "WS_REFRESH_HIERARCHY_DETAILS";
export const UPDATE_ACCOUNT_DETAILS = "UPDATE_ACCOUNT_DETAILS";
export const LOAD_EMAIL_SIGNATURE = "LOAD_EMAIL_SIGNATURE";
export const UPDATE_EMAIL_SIGNATURE = "UPDATE_EMAIL_SIGNATURE";
export const UPDATE_BROKERAGE_SUBDOMAIN = "UPDATE_BROKERAGE_SUBDOMAIN";
export const UPDATE_PROFILE_PHOTO = "UPDATE_PROFILE_PHOTO";
export const REMOVE_PROFILE_PHOTO = "REMOVE_PROFILE_PHOTO";
export const GET_EMAIL_VALIDATION = "GET_EMAIL_VALIDATION";
export const LOGIN = "LOGIN";
export const CREATE_ACCOUNT = "CREATE_ACCOUNT";
export const VERIFY_ACCOUNT_EMAIL = "VERIFY_ACCOUNT_EMAIL";
export const RESEND_CONFIRMATION_CODE = "RESEND_CONFIRMATION_CODE";
export const TO_ENABLE_MFA_SEND_CODE = "TO_ENABLE_MFA_SEND_CODE";
export const VALIDATE_OR_ENABLE_MFA = "VALIDATE_OR_ENABLE_MFA";
export const RESEND_MFA_CODE = "RESEND_MFA_CODE";
export const MFA_REMIND_ME_LATER = "MFA_REMIND_ME_LATER";
export const END_SESSION = "END_SESSION";
export const AGREED_REMARKETING_TERMS = "AGREED_REMARKETING_TERMS";
export const TOGGLE_FEATURE_DISCOVERY = "TOGGLE_FEATURE_DISCOVERY";
export const TOGGLE_APPLICATION_FEATURE_DISCOVERY = "TOGGLE_APPLICATION_FEATURE_DISCOVERY";
export const LOAD_STYLES = "LOAD_STYLES";
export const CHECK_SUBDOMAIN = "CHECK_SUBDOMAIN";
export const UPDATE_DEFAULT_REPORTS_PREFERENCE = "UPDATE_DEFAULT_REPORTS_PREFERENCE";
export const UPDATE_AI_EMAIL_PREFERENCES = "UPDATE_AI_EMAIL_PREFERENCES";
const actions = {
  [INIT_SESSION]: (context, session) => {
    context.commit(SET_SESSION_DETAILS, session);
  },
  [END_SESSION]: context => {
    $["flushPool"]();
    Amplitude.endSession();
    context.commit("clearState", {}, {
      root: true
    });
  },
  [UPDATE_ACCOUNT_PREFERENCES]: async (context, accountPreferences = context.state.accountPreferences) => {
    try {
      await updateAccountPreferences(accountPreferences);
      context.commit(SET_ACCOUNT_PREFERENCES, {
        accountPreferencesDetails: accountPreferences
      });
      PendoUtils.updateVisitor(context.state);
      Amplitude.logEvent("Personal settings - account preferences changed", {
        preferences: context.state.accountPreferences,
        page: "personal-settings"
      });
    } catch (e) {
      Err.handle(e, {
        accountPreferences
      }, "Failed to update account preferences");
      throw e;
    }
  },
  [UPDATE_LOCALE_PREFERENCES]: async (context, languagePreferences) => {
    try {
      const currentUserDetails = context.state.userDetails;
      const {
        timezone
      } = context.state.accountDetails;
      const userDetails = _objectSpread(_objectSpread(_objectSpread({}, currentUserDetails), languagePreferences), {}, {
        timezone
      });
      await updatePersonalDetails(userDetails);
      context.commit(SET_ACCOUNT_DETAILS, {
        accountDetails: languagePreferences
      });
      PendoUtils.updateVisitor(context.state);
      Amplitude.logEvent("Personal settings - locale preferences changed", {
        preferences: context.state.userDetails,
        page: "personal-settings"
      });
    } catch (e) {
      Err.handle(e, {
        languagePreferences
      }, "failedToUpdateAccountPreferences");
      throw e;
    }
  },
  [LOAD_NOTIFICATION_PREFERENCES]: async context => {
    try {
      const preferences = await getNotificationPreferences();
      context.commit(SET_NOTIFICATION_PREFERENCES, {
        preferences
      });
    } catch (e) {
      Err.handle(e, {}, "failedToLoadNotificationPreferences");
    }
  },
  [LOAD_PERSONAL_DETAILS]: async context => {
    try {
      const {
        userDetails,
        accountDetails,
        accountPreferences,
        brokerageDetails
      } = await getAccountDetails();
      context.commit(SET_PERSONAL_DETAILS, {
        userDetails
      });
      context.commit(SET_ACCOUNT_DETAILS, {
        accountDetails
      });
      context.commit(SET_ACCOUNT_PREFERENCES, {
        accountPreferencesDetails: accountPreferences
      });
      context.commit(SET_TIED_BROKERAGE, {
        tiedBrokerage: brokerageDetails
      });
    } catch (e) {
      Err.handle(e, {}, "failedToLoadNotificationPreferences");
    }
  },
  [WS_REFRESH_HIERARCHY_DETAILS]: async context => {
    await context.dispatch(LOAD_PERSONAL_DETAILS);
    Vue.router.go(0);
  },
  [UPDATE_ACCOUNT_PERSONAL_DETAILS]: async (context, {
    details
  }) => {
    try {
      const currentUserDetails = context.state.userDetails;
      const userDetails = _objectSpread(_objectSpread({}, currentUserDetails), details);
      await updatePersonalDetails(userDetails);
      context.commit(SET_PERSONAL_DETAILS, {
        userDetails
      });
      PendoUtils.updateVisitor(context.state);
    } catch (e) {
      Err.handle(e, {}, "failedToUpdatePersonalDetails");
    }
  },
  [UPDATE_ACCOUNT_DETAILS]: async (context, {
    details
  }) => {
    try {
      const currentAccountDetails = context.state.accountDetails;
      const accountDetails = _objectSpread(_objectSpread({}, currentAccountDetails), details);
      context.commit(SET_ACCOUNT_DETAILS, {
        accountDetails
      });
      PendoUtils.updateVisitor(context.state);
    } catch (e) {
      Err.handle(e, {}, "failedToUpdatePersonalDetails");
    }
  },
  [UPDATE_NOTIFICATION_PREFERENCES]: async (context, {
    preferences
  }) => {
    var _context;
    const currentPreferences = context.state.notificationPreferences;
    const clearedPreferences = clearPreferencesBooleans(preferences);
    const parsedPreferences = _reduceInstanceProperty(_context = _Object$values(clearedPreferences)).call(_context, (acc, current) => {
      return _objectSpread(_objectSpread({}, acc), current);
    }, {});
    const filteredPreferences = omitDeep(parsedPreferences, ["emailSupported"]);
    try {
      await updateNotificationPreferences(filteredPreferences);
      context.commit(SET_NOTIFICATION_PREFERENCES, {
        preferences: clearedPreferences
      });
    } catch (e) {
      context.commit(SET_NOTIFICATION_PREFERENCES, {
        preferences: currentPreferences
      });
      Err.handle(e, {}, "failedToUpdateNotificationPreferences");
    }
  },
  [SAVE_BOARD_VIEW]: async (context, {
    clientBoardView
  }) => {
    const currentClientBoardView = context.state.clientBoardView;
    try {
      context.commit(SET_CLIENT_BOARD_VIEW, {
        clientBoardView
      });
      await updateAccountPreferences({
        clientBoardView
      });
    } catch (e) {
      context.commit(SET_CLIENT_BOARD_VIEW, {
        clientBoardView: currentClientBoardView
      });
    }
  },
  [TOGGLE_FEATURE_DISCOVERY]: async (context, {
    featureDiscovery
  }) => {
    const currentFeatureDiscovery = context.state.accountPreferences.featureDiscovery;
    try {
      context.commit(SET_ACCOUNT_PREFERENCES, {
        accountPreferencesDetails: {
          featureDiscovery
        }
      });
      await updateAccountPreferences({
        featureDiscovery
      });
      PendoUtils.updateVisitor(context.state);
    } catch (e) {
      context.commit(SET_ACCOUNT_PREFERENCES, {
        accountPreferencesDetails: {
          featureDiscovery: currentFeatureDiscovery
        }
      });
    }
  },
  [TOGGLE_APPLICATION_FEATURE_DISCOVERY]: async (context, {
    applicationFeatureDiscovery
  }) => {
    const currentApplicationFeatureDiscovery = context.state.accountPreferences.featureDiscovery;
    try {
      context.commit(SET_ACCOUNT_PREFERENCES, {
        accountPreferencesDetails: {
          applicationFeatureDiscovery
        }
      });
      if (!applicationFeatureDiscovery) {
        await updateAccountPreferences({
          applicationFeatureDiscovery
        });
        PendoUtils.updateVisitor(context.state);
      }
    } catch (e) {
      context.commit(SET_ACCOUNT_PREFERENCES, {
        accountPreferencesDetails: {
          featureDiscovery: currentApplicationFeatureDiscovery
        }
      });
    }
  },
  [LOAD_EMAIL_SIGNATURE]: async context => {
    try {
      const {
        emailSignature
      } = await getEmailSignature();
      context.commit(SET_EMAIL_SIGNATURE, emailSignature);
    } catch (e) {
      Err.handle(e, {}, "failedToLoadEmailSignature");
    }
  },
  [UPDATE_EMAIL_SIGNATURE]: async (context, emailSignature) => {
    try {
      await updateEmailSignature(emailSignature);
      context.commit(SET_EMAIL_SIGNATURE, emailSignature);
    } catch (e) {
      Err.handle(e, {}, "failedToUpdateEmailSignature");
    }
  },
  [UPDATE_BROKERAGE_SUBDOMAIN]: async (context, subdomain) => {
    try {
      await updateDomain(subdomain);
      const accountDetails = {
        accountSubdomain: subdomain
      };
      context.commit(SET_ACCOUNT_DETAILS, {
        accountDetails
      });
    } catch (e) {
      var _e$responseJSON$messa, _e$responseJSON;
      const message = (_e$responseJSON$messa = (_e$responseJSON = e.responseJSON) == null ? void 0 : _e$responseJSON.message) != null ? _e$responseJSON$messa : "failedToUpdateBrokerageSubdomain";
      Err.handle(e, {}, message);
      throw e;
    }
  },
  [UPDATE_PROFILE_PHOTO]: async (context, {
    croppedImage,
    username
  }) => {
    try {
      var _context$state$userDe, _context$state, _context$state$userDe2;
      const name = `profile-${username}.png`;
      const signed = await getPhotoSignedURL(name);
      await uploadToS3(croppedImage, signed.url, signed.contentType);
      await setProfilePhoto();
      context.commit(SET_PERSONAL_DETAILS, {
        userDetails: {
          photoVersion: ((_context$state$userDe = (_context$state = context.state) == null ? void 0 : (_context$state$userDe2 = _context$state.userDetails) == null ? void 0 : _context$state$userDe2.photoVersion) != null ? _context$state$userDe : 0) + 1,
          profilePhoto: true
        }
      });
    } catch (e) {
      Err.handle(e, {}, "failedToUpdateProfilePhoto");
    }
  },
  [REMOVE_PROFILE_PHOTO]: async context => {
    try {
      await removeProfilePhoto();
      context.commit(SET_PERSONAL_DETAILS, {
        userDetails: {
          profilePhoto: false
        }
      });
    } catch (e) {
      Err.handle(e, {}, "failedToRemoveProfilePhoto");
    }
  },
  [GET_EMAIL_VALIDATION]: async (context, {
    email,
    type
  }) => {
    try {
      const {
        valid
      } = await getAccountType({
        email,
        type
      });
      return valid;
    } catch (e) {
      Err.handle(e, "", "failedToValidateEmail");
      throw e;
    }
  },
  [LOGIN]: async (context, {
    email,
    password,
    subdomain,
    deviceConfig
  }) => {
    try {
      const res = await login(email, password, subdomain != null ? subdomain : "", deviceConfig);
      res.email = email;
      return res;
    } catch (e) {
      var _e$responseJSON2;
      const responseJSONCode = (_e$responseJSON2 = e.responseJSON) == null ? void 0 : _e$responseJSON2.code;
      if (responseJSONCode === "UserNotConfirmedException" || responseJSONCode == 6) {
        context.commit(SET_EMAIL_VERIFICATION, {
          pendingEmailVerification: true,
          email: email
        });
        return {
          pendingEmailVerification: true
        };
      }
      if (responseJSONCode === "LimitExceededException") {
        e.responseJSON.message = i18n.t("notification-messages.attemptLimitExceeded");
      }
      Err.handle(e, {}, !e.responseJSON && e.message);
    }
    return false;
  },
  [CREATE_ACCOUNT]: async (context, {
    accountDetails
  }) => {
    try {
      await createAccount(accountDetails);
      context.commit(SET_EMAIL_VERIFICATION, {
        pendingEmailVerification: true,
        email: accountDetails.email
      });
      return true;
    } catch (e) {
      Err.handle(e);
      return false;
    }
  },
  [VERIFY_ACCOUNT_EMAIL]: async (context, {
    email,
    code
  }) => {
    try {
      await verifyAccountEmail(email, code);
      return true;
    } catch (e) {
      Err.handle(e);
      return false;
    }
  },
  [RESEND_CONFIRMATION_CODE]: async (context, {
    email
  }) => {
    try {
      await resendConfirmationCode(email);
      return true;
    } catch (e) {
      Err.handle(e);
      return false;
    }
  },
  [TO_ENABLE_MFA_SEND_CODE]: async (context, {
    token,
    mfaValue,
    mfaMethod,
    username
  }) => {
    try {
      await confirmSelectedMfaAndSendCode(token, mfaValue != null ? mfaValue : "", username, mfaMethod != null ? mfaMethod : "");
      return true;
    } catch (e) {
      var _e$responseJSON3;
      const responseJSONCode = (_e$responseJSON3 = e.responseJSON) == null ? void 0 : _e$responseJSON3.code;
      if (responseJSONCode === "LimitExceededException") {
        e.responseJSON.message = i18n.t("notification-messages.attemptLimitExceeded");
      }
      Err.handle(e, {}, !e.responseJSON && e.message);
      return false;
    }
  },
  [VALIDATE_OR_ENABLE_MFA]: async (context, {
    mfaMethod,
    session,
    userId,
    token,
    mfaCode,
    subdomain,
    isTrustedDevice = false
  }) => {
    try {
      const payload = {
        mfaCode: mfaCode != null ? mfaCode : "",
        session: session != null ? session : "",
        userId: userId != null ? userId : "",
        isTrustedDevice,
        mfaMethod
      };
      const res = mfaCode && session ? await validateMfa(payload) : await enableMfa({
        username: userId != null ? userId : null,
        session: session != null ? session : null,
        token: token != null ? token : null,
        mfaCode: mfaCode != null ? mfaCode : null,
        subdomain: subdomain != null ? subdomain : null,
        isTrustedDevice,
        mfaMethod
      });
      return res;
    } catch (e) {
      var _e$responseJSON4;
      const responseJSONCode = (_e$responseJSON4 = e.responseJSON) == null ? void 0 : _e$responseJSON4.code;
      if (responseJSONCode === "CodeMismatchException") {
        e.responseJSON.message = i18n.t("notification-messages.invalidMfaCode");
      }
      Err.handle(e, {}, !e.responseJSON && e.message);
      return false;
    }
  },
  [MFA_REMIND_ME_LATER]: async (context, {
    token,
    mfaPreferences,
    username
  }) => {
    try {
      return await snoozeMfaForLater(token, mfaPreferences, username);
    } catch (e) {
      Err.handle(e, {}, !e.responseJSON && e.message);
      return false;
    }
  },
  [AGREED_REMARKETING_TERMS]: async context => {
    try {
      await agreedToTerms();
      context.commit(SET_ACCOUNT_DETAILS, {
        accountDetails: {
          agreedToRemarketingTerms: true
        }
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [LOAD_STYLES]: async context => {
    const colors = getCurrentColor();
    context.commit(SET_STYLES, {
      styles: colors
    });
  },
  [CHECK_SUBDOMAIN]: async context => {
    try {
      const {
        token,
        brokerageDetails: {
          tiedBrokerages
        },
        accountDetails: {
          accountSubdomain
        }
      } = context.state;
      const path = window.location.pathname.replace("/", "").replace("#", "");
      const hasActiveSession = !!token;
      const endpoint = `/subdomain/${path}`;
      if (!hasActiveSession) return;
      await getAccountsApi({}, endpoint);
      const isTiedBrokerage = find(tiedBrokerages, brokerage => brokerage.subdomain === path);
      if (!isTiedBrokerage && path !== accountSubdomain) {
        await delay(500);
        location.replace(`/${accountSubdomain}`);
      }
    } catch (e) {
      Amplitude.logEvent("Domain not found - redirected to own domain", {
        error: e
      });
      await delay(500);
      location.replace("/");
    }
  },
  [UPDATE_DEFAULT_REPORTS_PREFERENCE]: async (context, reportDefaultSettings) => {
    try {
      const updatedSettings = _objectSpread(_objectSpread({}, context.state.accountPreferences.reportDefaultSettings), reportDefaultSettings);
      await updateAccountPreferences({
        reportDefaultSettings: updatedSettings
      });
      context.commit(SET_ACCOUNT_PREFERENCES, {
        accountPreferencesDetails: {
          reportDefaultSettings: updatedSettings
        }
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_AI_EMAIL_PREFERENCES]: async (context, aiEmailDefaultSettings) => {
    try {
      const updatedSettings = _objectSpread(_objectSpread({}, context.state.accountPreferences.aiEmailDefaultSettings), aiEmailDefaultSettings);
      await updateAccountPreferences({
        aiEmailDefaultSettings: updatedSettings
      });
      context.commit(SET_ACCOUNT_PREFERENCES, {
        accountPreferencesDetails: {
          aiEmailDefaultSettings: updatedSettings
        }
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [RESEND_MFA_CODE]: async (context, {
    username
  }) => {
    try {
      await resendMfaCode({
        username
      });
    } catch (e) {
      Err.handle(e);
    }
  }
};
export default actions;